module.exports = __webpack_public_path__ + "static/media/d1ru.354ecf73.pdf";